import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Loop } from "./Loop";
import { PatternGenerator } from "./PatternGenerator";
import { optionsFromArguments } from "../core/util/Defaults";
import { noOp } from "../core/util/Interface";
/**
 * Pattern arpeggiates between the given notes
 * in a number of patterns.
 * @example
 * const pattern = new Tone.Pattern((time, note) => {
 * 	// the order of the notes passed in depends on the pattern
 * }, ["C2", "D4", "E5", "A6"], "upDown");
 * @category Event
 */
export var Pattern = /*#__PURE__*/function (_Loop) {
  _inherits(Pattern, _Loop);
  function Pattern() {
    var _this;
    _classCallCheck(this, Pattern);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pattern).call(this, optionsFromArguments(Pattern.getDefaults(), arguments, ["callback", "values", "pattern"])));
    _this.name = "Pattern";
    var options = optionsFromArguments(Pattern.getDefaults(), arguments, ["callback", "values", "pattern"]);
    _this.callback = options.callback;
    _this._values = options.values;
    _this._pattern = PatternGenerator(options.values, options.pattern);
    _this._type = options.pattern;
    return _this;
  }
  _createClass(Pattern, [{
    key: "_tick",
    /**
     * Internal function called when the notes should be called
     */
    value: function _tick(time) {
      var value = this._pattern.next();
      this._value = value.value;
      this.callback(time, this._value);
    }
    /**
     * The array of events.
     */
  }, {
    key: "values",
    get: function get() {
      return this._values;
    },
    set: function set(val) {
      this._values = val;
      // reset the pattern
      this.pattern = this._type;
    }
    /**
     * The current value of the pattern.
     */
  }, {
    key: "value",
    get: function get() {
      return this._value;
    }
    /**
     * The pattern type. See Tone.CtrlPattern for the full list of patterns.
     */
  }, {
    key: "pattern",
    get: function get() {
      return this._type;
    },
    set: function set(pattern) {
      this._type = pattern;
      this._pattern = PatternGenerator(this._values, this._type);
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Loop.getDefaults(), {
        pattern: "up",
        values: [],
        callback: noOp
      });
    }
  }]);
  return Pattern;
}(Loop);